<template>
  <div>
    <div @change="changeHandler" class="is-flex-desktop" :class="isFirst? 'shorter' : ''">
        <div class="field has-addons">
          <div class="control">
            <label v-if="isFirst" class="label is-small">Qty ({{totalQuantity}})<abbr class="req" title="required">*</abbr></label>
            <input :class="isFirst? 'invisible' : ''" class="input is-narrow is-small" type="number" min="0" v-model.number="qty" placeholder="0" :required="required">
          </div>
          <div class="control">
            <label v-if="isFirst" class="label is-small">IB/OB <abbr class="req" title="required">*</abbr></label>
            <div :class="isFirst? 'invisible' : ''" class="select is-small">
              <select name="ibob" v-model="size.ibob" :required="required">
                <option value="IB">IB</option>
                <option value="OB">OB</option>
                <option value="FM">FM</option>
              </select>
            </div>
          </div>
          <div class="control">
            <label v-if="isFirst" class="label is-small">Room</label>
            <input  :class="isFirst? 'invisible' : ''" class="input is-small" type="text" v-model="room" placeholder="room name">
          </div>
        </div>
        <div class="field has-addons">
          <div class="control">
            <label v-if="isFirst" class="label is-small">Width <abbr class="req" title="required">*</abbr></label>
            <input :class="isFirst? 'invisible' : ''" class="input is-narrow is-small" type="number" min="0" v-model.number="size.width" placeholder="0" :required="required">
          </div>
          <div class="control">
            <label v-if="isFirst"  class="label is-small">&nbsp;</label>
            <div :class="isFirst? 'invisible' : ''" class="select is-small">
              <select v-model="size.width_fraction">
                <option selected></option>
                <option>1/8</option>
                <option>1/4</option>
                <option>3/8</option>
                <option>1/2</option>
                <option>5/8</option>
                <option>3/4</option>
                <option>7/8</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field has-addons">
          <div class="control">
            <label v-if="isFirst" class="label is-small">Height <abbr class="req" title="required">*</abbr></label>
            <input :class="isFirst? 'invisible' : ''" class="input is-narrow is-small" type="number" min="0" v-model.number="size.height" placeholder="0" :required="required">
          </div>
          <div class="control">
            <label v-if="isFirst" class="label is-small">&nbsp;</label>
            <div :class="isFirst? 'invisible' : ''" class="select is-small">
              <select v-model="size.height_fraction">
                <option selected></option>
                <option>1/8</option>
                <option>1/4</option>
                <option>3/8</option>
                <option>1/2</option>
                <option>5/8</option>
                <option>3/4</option>
                <option>7/8</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field has-addons">
          <div class="control" >
            <label v-if="isFirst" class="label is-small">Style <abbr class="req" title="required">*</abbr></label>
            <div class="select is-small" :class="isFirst? 'invisible' : ''">
            <select
              @keyup.delete="reset('fabric', 'style')"
              class="fixed-select"
              v-model="fabric.style"
              placeholder="style"
            >
              <option v-for="(fabricStyle, idx) in distinctFabricStyles" :key="idx" :value="fabricStyle">{{fabricStyle}}</option>
            </select>
            </div>
          </div>
        <div class="control">
            <label v-if="isFirst" class="label is-small">Fabric Color <abbr class="req" title="required">*</abbr></label>
            <div class="select is-small" :class="isFirst? 'invisible' : ''">
            <select
            @keyup.delete="reset('fabric', 'color')"
              class="fixed-select"
              v-model="fabric.color"
              placeholder="color"
            >
            <option v-for="(fabricColor, idx) in distinctFabricColors" :key="idx" :value="fabricColor">{{fabricColor}}</option>
            </select>
            </div>
          </div>
        
          <div class="control">
            <label v-if="isFirst" class="label is-small">Fabric Roll</label>
            <div class="select is-small"  :class="isFirst? 'invisible' : ''">
              <select name="roll" v-model="fabric.roll" :required="required">
              <option value="rev">Reverse</option>
              <option value="reg">Regular</option>
            </select></div>
          </div>
          </div>
        <div class="field has-addons">
          <div class="control">
            <label v-if="isFirst" class="label is-small">Chain Color <abbr class="req" title="required">*</abbr></label>
            <div  :class="isFirst? 'invisible' : ''" class="select is-small">
              <select
                v-model="chain.color"
                @keyup.delete="reset('chain', 'color')"
                class="fixed-select"
                :class="chain.color === 'default' ? 'select-default' : ''"
                :required="required"
              >
                <option value="default" selected disabled>Color:</option>
                <option v-for="color in distinctChainColors" :key="color" class="option">{{color}}</option>
              </select>
            </div>
          </div>
          <div class="control">
            <label v-if="isFirst" class="label is-small">Chain Material <abbr class="req" title="required">*</abbr></label>
            <div :class="isFirst? 'invisible' : ''" class="select is-small">
              <select
                v-model="chain.material"
                @keyup.delete="reset('chain', 'material')"
                class="fixed-select"
                :class="chain.material === 'default' ? 'select-default' : ''"
                :required="required"
              >
                <option value="default" selected disabled>Material:</option>
                <option v-for="material in distinctChainMaterials" :key="material" class="option">{{material}}</option>
              </select>
            </div>
          </div>
          <div class="control">
            <label v-if="isFirst" class="label is-small">Length</label>
            <input :class="isFirst? 'invisible' : ''" class="input is-narrow is-small" type="number" min="0" v-model="chain.length" placeholder="0">
          </div>
         <div class="control">
            <label v-if="isFirst" class="label is-small">Control <abbr class="req" title="required">*</abbr></label>
            <div :class="isFirst? 'invisible' : ''" class="select is-small">
              <select name="direction" v-model="chain.direction" :required="required">
                <option value="right">Right</option>
                <option value="left">Left</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field has-addons">
          <div class="control">
            <label v-if="isFirst" class="label is-small">Valance Type</label>
            <div class="select is-small" :class="isFirst? 'invisible': ''">
            <select :class="isFirst? 'invisible' : ''"
              class="fixed-select"
              v-model="valance.type"
            >
              <option v-for="(valanceType, idx) in valanceTypes" :key="idx" :value="valanceType.valance_type">{{valanceType.valance_type}}</option>
            </select>
            </div>
          </div>
          <div class="control">
            <label v-if="isFirst" class="label is-small">Valance Color</label>
            <div class="select is-small" :class="isFirst? 'invisible': ''">
            <select :class="isFirst? 'invisible' : ''"
              class="fixed-select"
              v-model="valance.color"
            >
              <option v-for="(valanceColor, idx) in valanceColors" :key="idx" :value="valanceColor.color">{{valanceColor.color}}</option>
            </select>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <label v-if="isFirst" for="" class="label is-small">Notes</label>
            <!-- <textarea :class="isFirst? 'invisible' : ''" class="textarea is-small" v-model="notes"></textarea> -->
            <textarea v-model="notes" :class="isFirst? 'invisible' : ''" class="input is-small"></textarea>
          </div>
          </div>
    </div>
  </div>
</template>


<script>

export default {
  props: ['values', 'category', 'orderOptions', 'required', 'isFirst', 'totalQty'],
  watch: {
    totalQty: {
      handler(newVal) {
        console.log('total qty changing');
        this.totalQuantity = newVal;
      },
    },
  },
  data() {
    return {
      fabricColor: '',
      totalQuantity: this.totalQty,
      fabricStyleSearchTerm: this.values.fabric ? this.values.fabric.style : '',
      fabricColorSearchTerm: '',
      valanceTypeSearchTerm: '',
      id: this.values.id || -1,
      qty: this.values.qty || null,
      room: this.values.room || null,
      size: {
        width: this.values.size ? this.values.size.width : null,
        width_fraction: this.values.size ? this.values.size.width_fraction : null,
        height: this.values.size ? this.values.size.height : null,
        height_fraction: this.values.size ? this.values.size.height_fraction : null,
        ibob: this.values.size ? this.values.size.ibob : null,
      },
      fabric: {
        style: this.values.fabric ? this.values.fabric.style : '',
        color: this.values.fabric ? this.values.fabric.color : '',
        roll: this.values.fabric ? this.values.fabric.roll : null,
      },
      chain: {
        color: this.values.chain ? this.values.chain.color : 'default',
        material: this.values.chain ? this.values.chain.material : 'default',
        direction: this.values.chain ? this.values.chain.direction : null,
        length: this.values.chain ? this.values.chain.length : null,
      },
      valance: {
        type: this.values.valance ? this.values.valance.type : null,
        color: this.values.valance ? this.values.valance.color : null,
      },
      notes: this.values.notes || null,
    };
  },
  methods: {
    updateNotes(e) {
      this.notes = e.target.innerText;
    },
    changeHandler() {
      this.$emit('cell-changed', this.$data);
    },
    reset(field1, field2) {
      this[field1][field2] = '';
    },
    changed() {
    },

  },
  computed: {
    valanceTypes() {
      return this.orderOptions && this.orderOptions.valances ? this.orderOptions.valances : [];
    },
    valanceColors() {
      return this.orderOptions && this.orderOptions.valanceColors ? this.orderOptions.valanceColors : [];
    },
    distinctChainColors() {
      if (this.orderOptions && this.orderOptions.chains) {
        return [...new Set(this.orderOptions.chains.filter(c => (this.chain.material && this.chain.material !== 'default' ? c.material === this.chain.material : true)).map(c => c.color))];
      }
      return [];
    },
    distinctChainMaterials() {
      if (this.orderOptions && this.orderOptions.chains) {
        return [...new Set(this.orderOptions.chains.filter(c => (this.chain.color && this.chain.color !== 'default' ? c.color === this.chain.color : true)).map(c => c.material))];
      }
      return [];
    },
    distinctFabricStyles() {
      if (this.orderOptions && this.orderOptions.fabricColors) {
        return [
          ...new Set(
            this.orderOptions
              .fabricColors
              .filter(c => (this.fabric.color ? c.color === this.fabric.color : true))
              .map(c => c.fabric),
          ),
        ].sort();
      }
      return [];
    },
    distinctFabricColors() {
      if (this.orderOptions && this.orderOptions.fabricColors) {
        return [
          ...new Set(
            this.orderOptions
              .fabricColors
              .filter(c => (this.fabric.style ? c.fabric === this.fabric.style : true))
              .map(c => c.color),
          ),
        ].sort();
      }
      return [];
    },
  },
};
</script>

<style scoped>
.field {
  margin-right: 10px;
}
.fixed-select {
  min-width: 120px;
  max-width: 120px;
}
.fill-up {
  flex-grow: 1;
}
.shorter {
  height: 2em;
  padding-bottom: 0px;
}
.label {
  margin-bottom: 0px;
}
.invisible {
  visibility: hidden;
  /* line-height:0px;
  max-height: 0px;
  height: 0px;
  padding: 0px;
  overflow: hidden;
  border: none; */
}

input.is-narrow {
  width: 60px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
    -moz-appearance:textfield;
}

.req {
  text-decoration: none;
}

.option {
  color: black
}

.select-default {
  color: lightgray;
}
textarea {
  /* height: 2.25em; */
  /* padding: 0px; */
}
  .buttons {
    justify-content: center;
  }
  hr {
    color: black;
    background-color: black;
    margin: 0;
  }
</style>
